import { ETAnnotation } from '../../../../components/ExperienceTimeline';

// At Overview zoom (8px columns), adjacent per-day cohort-position buckets
// visually collide. Merges buckets whose days fall within `minGapDays` of
// each other into one, summing counts and concatenating the underlying
// `data` arrays (so the existing hover popover can still list every
// instance). Buckets are merged left-to-right in day order; a merged
// bucket's day is its first (earliest) member's day, and its key is that
// member's key (stable across re-renders as long as the earliest bucket in
// a cluster doesn't change).
export const mergeAnnotationBuckets = <T,>(
  annotations: ETAnnotation[],
  minGapDays: number
): ETAnnotation[] => {
  if (minGapDays <= 1) return annotations;

  const sorted = [...annotations].sort((a, b) => a.day - b.day);
  const merged: ETAnnotation[] = [];

  sorted.forEach((a) => {
    const last = merged[merged.length - 1];
    if (last && a.day - last.day < minGapDays) {
      last.count += a.count;
      if (Array.isArray(last.data) && Array.isArray(a.data)) {
        last.data = [...(last.data as T[]), ...(a.data as T[])];
      }
    } else {
      merged.push({ ...a, data: Array.isArray(a.data) ? [...(a.data as T[])] : a.data });
    }
  });

  return merged;
};
